import { get } from 'lodash';
import { EventCategory } from '@lendi/analytics-web';

import { lendiAnalytics } from './analytics';
import { eventTracking, maskPIISegmentTracking } from './base';

// Form event
const FORM_ANSWER = 'Form Element Answered';
export function formSubmitTracking<T>(
  analytics: ReturnType<typeof lendiAnalytics>,
  values: T,
  dirtyFields: { [key: string]: boolean }
) {
  Object.keys(dirtyFields).forEach((fieldPath, i) => {
    const answer = get(values, fieldPath, null);
    answer &&
      eventTracking(analytics, {
        event_name: FORM_ANSWER,
        category: EventCategory.FUNNELS,
        question: fieldPath,
        answer: maskPIISegmentTracking(fieldPath, answer.toString()),
        position: `${i}`,
      });
  });
}
